import config from "./common.js"; //公共变量
import Cookies from "js-cookie";
import http from "./ajax.js"; //ajax请求
const browser = {
  versions: (function() {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Firefox") > -1, //火狐内核Gecko
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android
      iPhone: u.indexOf("iPhone") > -1, //iPhone
      iPad: u.indexOf("iPad") > -1, //iPad
      webApp: u.indexOf("Safari") > -1, //Safari
      user: u
    };
  })()
};
// 工具
var tools = {
  android: browser.versions.android, //安卓
  trident: browser.versions.trident, //IE内核
  presto: browser.versions.presto, //opera内核
  webKit: browser.versions.webKit, //苹果、谷歌内核
  gecko: browser.versions.gecko, //火狐内核Gecko
  mobile: browser.versions.mobile, //是否为移动终端
  ios: browser.versions.ios, //ios
  iPhone: browser.versions.iPhone, //iPhone
  iPad: browser.versions.iPad, //iPad
  webApp: browser.versions.webApp, //Safari
  user: browser.versions.user, //Safari
  // 设置网页标题
  setWebTitle(title) {
    console.log("setWebTitle", title);
    setTimeout(function() {
      document.getElementsByTagName("title")[0].innerText = title;
    }, 100);
  },
  isIOS: function() {
    /* istanbul ignore next */
    return /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
  },
  //微信
  isWeiXin: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  //过滤空格
  trim: function(val) {
    return val.replace(/(^\s*)|(\s*$)/g, "");
  },
  //删除地址栏参数
  delQueStr: function(url, ref) {
    var str = "";
    if (url.indexOf("?") != -1) {
      str = url.substr(url.indexOf("?") + 1);
    } else {
      return url;
    }
    var arr = "";
    var returnurl = "";
    var setparam = "";
    if (str.indexOf("&") != -1) {
      arr = str.split("&");
      for (var i in arr) {
        if (arr[i].split("=")[0] != ref) {
          returnurl =
            returnurl + arr[i].split("=")[0] + "=" + arr[i].split("=")[1] + "&";
        }
      }
      return (
        url.substr(0, url.indexOf("?")) +
        "?" +
        returnurl.substr(0, returnurl.length - 1)
      );
    } else {
      arr = str.split("=");
      if (arr[0] == ref) {
        return url.substr(0, url.indexOf("?"));
      } else {
        return url;
      }
    }
  },
  //设置本地储存
  setLocal: function(name, value, type) {
    var curTime = new Date().getTime();
    if (!type || type == 2) {
      //默认设置-之前存在则使用创建时间
      var data = localStorage.getItem(name);
      if (!data || data == "null") {
        localStorage.setItem(
          name,
          JSON.stringify({
            data: value,
            time: curTime
          })
        );
      } else {
        var dataObj = JSON.parse(data);
        var setTime = dataObj.time;
        localStorage.setItem(
          name,
          JSON.stringify({
            data: value,
            time: setTime
          })
        );
      }
    } else if (type == 1) {
      //type:1重新创建
      localStorage.setItem(
        name,
        JSON.stringify({
          data: value,
          time: curTime
        })
      );
    }
  },
  //获取本地储存
  getLocal: function(name, exp) {
    var data = localStorage.getItem(name);
    var dataObj = JSON.parse(data);
    if (!exp) {
      var exp = 1000 * 60 * 60 * 24 * 3;
    }
    if (dataObj && new Date().getTime() - dataObj.time > exp) {
      localStorage.removeItem(name);
      console.log("信息已过期");
      return null;
    } else {
      var dataObjDatatoJson = !dataObj ? null : dataObj.data;
      return dataObjDatatoJson;
    }
  },

  /*
   * 深复制
   * params
   * -destination  被赋值的新对象
   * -source  取值的对象
   * -miss  忽略的对象
   * */
  deepCopy: function(destination, source, miss) {
    for (var p in source) {
      if (_.isArray(p, miss) > -1) {
        return;
      }
      if (getType(source[p]) == "array" || getType(source[p]) == "object") {
        destination[p] = getType(source[p]) == "array" ? [] : {};
        arguments.callee(destination[p], source[p]);
      } else {
        destination[p] = source[p];
      }
    }
    function getType(o) {
      var _t;
      return ((_t = typeof o) == "object"
        ? (o == null && "null") ||
          Object.prototype.toString.call(o).slice(8, -1)
        : _t
      ).toLowerCase();
    }
  },
  getStorage(key, isSession) {
    const storage = isSession ? sessionStorage : localStorage;
    if (storage[key]) {
      let out = storage[key];
      try {
        out = JSON.parse(storage[key]);
      } catch (error) {
        console.log("解析localStorage." + key + "失败", error);
      }
      return out;
    }
  },
  setStorage(key, data, isSession) {
    if (typeof data == "object") {
      try {
        data = JSON.stringify(data);
      } catch (error) {
        console.log("解析localStorage." + key + "失败", error);
      }
    }
    if (isSession) {
      sessionStorage.setItem(key, data);
    } else {
      localStorage.setItem(key, data);
    }
  },
  dateFormat(date, fmt) {
    if (date.getFullYear == undefined) {
      return "";
    }
    let ret;
    const opt = {
      "y+": date.getFullYear().toString(), // 年
      "M+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "h+": date.getHours().toString(), // 时
      "m+": date.getMinutes().toString(), // 分
      "s+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
        );
      }
    }
    return fmt;
  },
  //获取地址栏参数
  getQueryStringByName: function(name) {
    var result = location.search.match(
      new RegExp("[?&]" + name + "=([^&]+)", "i")
    );
    if (result == null || result.length < 1) {
      return "";
    }
    return result[1];
  },
  outLogin(url = location.href) {
    localStorage.removeItem("jzy_token");
    // localStorage.removeItem("jzy_openid");
    localStorage.removeItem("jzy_wxInfo");
    localStorage.removeItem("jzy_auth");
    localStorage.removeItem("jzy_user");
    sessionStorage.jzyLoginPage = url;
    location.replace("/apps/login");
  },
  getAppLoginInfo() {
    return new Promise((resolve, reject) => {
      if (config.isApp) {
        app.deviceready(res => {
          app.getDeviceInfo(res => {
            console.log("getDeviceInfo", res);
            if (typeof res == "string") {
              try {
                res = JSON.parse(res);
              } catch (error) {}
            }
            localStorage.jzyVersion = res.versionName;
          });
          app.getUserInfo(
            res => {
              console.log(res);
              if (typeof res == "string") {
                try {
                  res = JSON.parse(res);
                } catch (error) {}
              }

              try {
                if (res.data) {
                  // res.data.mechanUser.code = res.data.mechan.code;
                  localStorage.jzy_token = res.data.token;
                  localStorage.jzy_user = JSON.stringify(res.data);
                } else {
                  // res.mechanUser.code = res.mechan.code;
                  localStorage.jzy_token = res.token;
                  localStorage.jzy_user = JSON.stringify(res);
                }
                resolve();
              } catch (error) {
                console.log(error);
                console.log("保存用户信息异常");
                reject(error);
              }
            },
            res => {
              console.log("error", res);
              reject(res);
            }
          );
        });
      } else {
        resolve();
      }
    });
  },
  dealIosBack() {
    //ios回退前进缓存
    let browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function(event) {
        if (event.persisted) {
          //如果是从缓存中读取，则重新刷新页面
          window.location.reload();
        }
      };
    }
  },
  setCookie(key, value, time) {
    Cookies.set(key, value, { expires: time });
  },
  getCookie(key) {
    return Cookies.get(key);
  },
};
window.getMetaValue = tools.getMetaValue;
export default tools;
